import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Card from "react-bootstrap/Card";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import AxisSpinner from "../components/AxisSpinner";
import { CSSTransition, SwitchTransition } from "react-transition-group";

export function AdminStatisticsCardElement(
  title,
  endPoint = null,
  cardIcon = "",
  redirectUrl = "/#",
  redirectState = null,
) {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(false);

  const fetch = async () => {
    try {
      setLoading(true);

      const resp = await authAxios().get(endPoint);
      setResult(resp.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  useEffect(() => {
    fetch();

    let timer = setInterval(() => {
      fetch();
    }, 5000);
    return () => clearInterval(timer);
  }, [endPoint]);

  const SpinnerOrData = () => {
    if (loading && result === false) return <AxisSpinner loading={loading} />;
    return (
      <SwitchTransition>
        <CSSTransition classNames="fade" key={result?.value}>
          <div>{result?.value}</div>
        </CSSTransition>
      </SwitchTransition>
    );
  };

  return (
    <Col>
      <Card
        as={Link}
        className={"axis-card text-decoration-none"}
        to={redirectUrl}
        state={redirectState}
      >
        <Card.Body className={"hoverThis"}>
          <Container fluid>
            <Row className={"align-items-center"}>
              <Col>
                <Card.Title className={"text-axis-offblack"}>
                  {title}
                </Card.Title>
                <Card.Text className={"text-axis-offblack"}>
                  {SpinnerOrData()}
                </Card.Text>
              </Col>
              <Col className={"float-end align-content-end"}>{cardIcon}</Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    </Col>
  );
}
